import { render, staticRenderFns } from "./WeddingList.vue?vue&type=template&id=2e9cc92e&scoped=true"
import script from "./WeddingList.vue?vue&type=script&lang=js"
export * from "./WeddingList.vue?vue&type=script&lang=js"
import style0 from "./WeddingList.vue?vue&type=style&index=0&id=2e9cc92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9cc92e",
  null
  
)

export default component.exports